export default "__VITE_ASSET__4b31dcb4__"